import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/canonical.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  constructor(private meta: Meta, private title: Title, private canonicalService: CanonicalService) {
    this.title.setTitle("Contact Us - International Business Payment | SingX");
    this.canonicalService.updateCanonicalUrl('/contact-us');
    this.meta.updateTag({ name: 'description', content: 'Contact with SingX for International Business Payment which helps to transfer money globally. Send money today without any hidden charges and Unbeatable Exchange Rates. Get in Touch with us.' })
    this.meta.updateTag({ name: 'author', content: 'SingX' })
    this.meta.updateTag({ name: 'keywords', content: 'Instant Money Transfer Overseas, Money Transfer Overseas, International Money Transfer, remittance, Fast Money Transfer Overseas, Cheapest Way to Transfer Money Overseas, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' })
    // this.meta.addTags([
    //   { name: 'description', content: 'Contact with SingX for International Business Payment which helps to transfer money globally. Send money today without any hidden charges and Unbeatable Exchange Rates. Get in Touch with us.' },
    //   { name: 'author', content: 'SingX' },
    //   { name: 'keywords', content: 'Instant Money Transfer Overseas, Money Transfer Overseas, International Money Transfer, remittance, Fast Money Transfer Overseas, Cheapest Way to Transfer Money Overseas, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment.' }
    // ]);
  }

  ngOnInit(): void {
  }

}
